import { SignedTimetableDataDto, SignedTimetableDto } from '@app/data/dtos/mot/signed-timetable.dto';
import { SignedTimetable } from '@app/entities/models/mot/signed-timetables/signed-timetables.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapSignedTimetable: MapFromFn<SignedTimetableDto, SignedTimetable> = (value) =>
  Builder.forModel(SignedTimetable).date(value.date).documentId(value.documentId).build();

export const mapDataSignedTimetable: MapFromFn<SignedTimetableDataDto, SignedTimetableDto[]> = (value) =>
  value.data.map(mapSignedTimetable);
